import React from 'react';

import {SortHeaderFilter} from '@pb/kit-component-filters-v2';

type Direction = 'ASC' | 'DESC';

type Props = {
    caption: string,
    filterActive?: boolean,
    sortable?: boolean,
    showFilter?: boolean,
    direction?: Direction,
    defaultDirection?: Direction,
    onSort?: () => void,
    onReset: () => void,
    onApply: () => void,
    onCancel: () => void,
    contentWidth?: number,
    children: React.ReactNode,
};

export const HeaderFilter: React.FC<Props> = ({
    caption,
    filterActive,
    sortable = false,
    showFilter,
    direction,
    defaultDirection = 'ASC',
    onSort,
    onReset,
    onApply,
    onCancel,
    contentWidth,
    children,
}) => (
    <SortHeaderFilter
        caption={caption}
        filterActive={filterActive}
        sortable={sortable}
        showFilter={showFilter}
        direction={direction}
        defaultDirection={defaultDirection}
        onSort={onSort}
        onReset={onReset}
        onApply={onApply}
        onCancel={onCancel}>
        {contentWidth ? <div style={{width: contentWidth}}>{children}</div> : children}
    </SortHeaderFilter>
);
